module.exports = __webpack_public_path__ + "ba0ef37909e2ee7c120711cc400d38c2.pdf";